import { render, staticRenderFns } from "./ComplaintManage.vue?vue&type=template&id=6435bbe5&"
import script from "./ComplaintManage.vue?vue&type=script&lang=js&"
export * from "./ComplaintManage.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports